<template>
  <div>
    <base-header class="pb-6"></base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <h3 class="mb-0">Listado de Reclamos</h3>
        </div>
        <div class="row starter-page">
          <div class="container-fluid">
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="">

                <div class="d-inline-block pl-2">
                  <base-input addon-left-icon="ni ni-calendar-grid-58">
                    <flat-picker slot-scope="{focus, blur}"
                                 @on-open="focus"
                                 @on-close="blur"
                                 :config="dates.config"
                                 class="form-control datepicker"
                                 @input="dateRangeChange"
                                 placeholder="Seleccione fecha"
                                 v-model="dates.range">
                    </flat-picker>
                  </base-input>
                </div>
                <div class="d-inline-block pl-2">
                  Total: {{ pagination.totalItems }}
                </div>
              </div>



            </div>
            <vue-content-loading
              v-if="!queriedData"
              :width="300"
              :height="170"
              primary="#bdc3c7"
              secondary="#95a5a6"
            >
              <svg:rect x="20" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="0" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="15" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="30" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="45" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="60" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="75" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="90" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="105" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="120" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="135" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="150" rx="3" ry="3" width="110" height="8" />
              <circle cx="206" cy="155" r="5" />
              <circle cx="219" cy="155" r="5" />
              <circle cx="232" cy="155" r="5" />
              <circle cx="245" cy="155" r="5" />
            </vue-content-loading>
            <el-table
              class="table-responsive table-flush"
              header-row-class-name="thead-light"
              row-key="id"
              :data="queriedData"
              row-class-name
              v-if="queriedData.length !== 0"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              ></el-table-column>

              <el-table-column
                min-width="50px"
                align="right"
                label="ACCIONES"
                prop="foto"
              >
                <template v-slot="{ row }">
                  <el-tooltip
                    content="VER FOTO"
                    placement="top"
                    v-if="row.foto"
                  >
                    <base-button type="primary" @click="showModal(row.foto)">
                      <i class="ni ni-album-2"></i>
                    </base-button>
                  </el-tooltip>
                  <p v-else></p>
                </template>
              </el-table-column>
            </el-table>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  Mostrando {{ from }} to {{ to }} de {{ total }} registros
                </p>
              </div>
              <base-pagination
                class="pagination-no-border"
                @input="next"
                v-model="pagination.page"
                :per-page="pagination.rowsPerPage"
                v-if="pagination.totalItems > 10"
                :total="total"
              ></base-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--modal foto-->
    <CustomModal :is-modal="modals" @closeModal="modals = false" :closeOuth="true">
      <h5 class="modal-title">Adjunto:</h5>
      <div class="card bg-dark text-white border-0 mt-4">
        <img class="card-img" :src="img_url" alt="Adjunto" />
      </div>
      <template slot="footer">
        <base-button type="secondary" @click="modals = false"
        >Close</base-button
        >
      </template>
    </CustomModal>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip
} from "element-ui";
import axios from "axios";
import { mapActions, mapState, mapMutations } from "vuex";
import { VueContentLoading } from "vue-content-loading";
import flatPicker from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css';
import { Spanish } from 'flatpickr/dist/l10n/es'
import claimPaginationMixin from "../../mixin/claimPaginationMixin";
import { Modal } from "@/components";
import CustomModal from "../../components/CustomModal";

export default {
  name: "FoodcourtClaimsList",
  mixins: [claimPaginationMixin],
  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    VueContentLoading,
    Modal,
    CustomModal,
    flatPicker,
  },
  data() {
    return {
      modals: false,
      img_url: null,
      currentPage: 1,
      selectedRows: [],
      propsToSearch: ["detalle"],
      tableColumns: [
        {
          prop: "detalle",
          label: "Detalle",
          minWidth: 160,
          sortable: true
        },
        {
          prop: "fecha",
          label: "Fecha",
          minWidth: 100,
          sortable: true
        },
        {
          prop: "cliente",
          label: "Cliente",
          minWidth: 100,
          sortable: true
        }
      ],
      tableData: [],
      pageActual: 1,
      dates: {
        range: "",
        config:{allowInput: false, mode: 'range',locale: Spanish}
      },
      rangeDate:[]
    };
  },
  computed: {
    ...mapState("foodcourtClaims", ["claims", "pagination"])
  },
  methods: {
    ...mapActions("foodcourtClaims", ["GET_CLAIMS"]),
    ...mapMutations("foodcourtClaims", ["SET_CLAIMS", "SET_PAGINATION"]),
    dateRangeChange(val){
      const dates = val.split('a').map(item => {
        return item.trim()
      });
      dates.length === 2 ? this.rangeDate = dates : '';
    },
    showModal(url) {
      this.img_url = url;
      this.modals = true;
    }
  },
  watch:{
    rangeDate(val){
      this.SET_CLAIMS([]);
      this.SET_PAGINATION({})
      this.GET_CLAIMS({
        page:1,
        dates: val
      }).then(() => {
        this.pageActual = this.pagination.page;
      })
    }
  }
};
</script>

<style scoped>
.modal-dialog .modal-dialog-centered {
  max-width: 1200px !important;
}
</style>
